"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function predicateToInput(predicate) {
    if ('keyPath' in predicate) {
        return Object.assign(Object.assign({}, predicate), { value: Object.assign(Object.assign({}, predicate.value), { listValue: predicate.value.listValue
                    ? {
                        id: parseInt(predicate.value.listValue.id, 10),
                    }
                    : null }) });
    }
    else {
        return {
            booleanOperator: predicate.booleanOperator,
            predicates: predicate.predicates.map(predicateToInput),
        };
    }
}
exports.predicateToInput = predicateToInput;
